import {createSlice} from "@reduxjs/toolkit";
import {
    saveConsolidatedBulkInvEv,
    savePlantWiseBulkInvEv,
    saveSingleInvEv,
    updateBulkInvEv,
    updateSingleInvEv,
} from "./inv-ev-actions";
import {toast} from "react-toastify";

const initialState = {
    bulkMode: false,
    editMode: false,
    fetchedResponse: null,
    drawerOpen: false,
    updateNeeded: false,
    jobId: null,
    jobIds: [],
    categoryId: null,
    statusUpdateRequest: [],
    selectedJob: null,
    jobInfo: null,
    withoutTaxTotal: 0.0,
    withTaxTotal: 0.0,
    taxAmount: 0.0,
    submitLoading: false,
    charges: [],
    currencyId: null,
    stakeholderId: null,
    stakeholderName: null,
    hasShipperWiseData: false,
    shipperWiseData: {},
    selectAll: false,
    chhId: null,
    resetLocalState: true,
    moduleCategory: null,
    fromDate: null,
    toDate: null,
};

const invEvSlice = createSlice({
    name: "invEv",
    initialState,
    reducers: {
        setFromToDate: (state, action) => {
            return {
                ...state,
                fromDate: action.payload.fromDate,
                toDate: action.payload.toDate,
            };
        },
        setCategoryId(state, action) {
            return {...state, categoryId: action.payload};
        },
        setJobId(state, action) {
            return {
                ...state,
                jobId: action.payload,
            };
        },
        setJobIds(state, action) {
            return {
                ...state,
                jobIds: action.payload,
            };
        },
        setJobInfo(state, action) {
            return {
                ...state,
                jobInfo: action.payload,
            };
        },
        setUpdateNeeded(state, action) {
            return {
                ...state,
                updateNeeded: action.payload,
            };
        },
        setSelectedJob(state, action) {
            return {
                ...state,
                selectedJob: action.payload,
            };
        },
        setStatusUpdateRequest(state, action) {
            return {
                ...state,
                statusUpdateRequest: action.payload,
            };
        },
        openDrawer(state) {
            return {
                ...state,
                drawerOpen: true,
            };
        },
        closeDrawer(state) {
            return {
                ...state,
                drawerOpen: false,
            };
        },
        setEditMode(state, action) {
            return {
                ...state,
                editMode: action.payload,
            };
        },
        setBulkMode(state, action) {
            return {
                ...state,
                bulkMode: action.payload,
            };
        },
        setFetchedResponse(state, action) {
            return {...state, fetchedResponse: action.payload};
        },
        setIsSubmitLoading(state, action) {
            return {
                ...state,
                submitLoading: action.payload,
            };
        },
        setTaxInfo(state, action) {
            return {
                ...state,
                withoutTaxTotal: action.payload.withoutTaxTotal,
                withTaxTotal: action.payload.withTaxTotal,
                taxAmount: action.payload.taxAmount,
            };
        },
        setRequest(state, action) {
            return {
                ...state,
                charges: action.payload.charges,
                hasShipperWiseData: action.payload.hasShipperWiseData,
                shipperWiseData: action.payload.shipperWiseData,
            };
        },
        resetState() {
            return {...initialState, updateNeeded: true};
        },
        setCurrencyAndStakeholder(state, action) {
            return {
                ...state,
                currencyId: action.payload.currencyId,
                stakeholderId: action.payload.stakeholderId,
                stakeholderName: action.payload.stakeholderName,
            };
        },
        setChhId(state, action) {
            return {
                ...state,
                chhId: action.payload,
            };
        },
        setResetLocalState(state, action) {
            return {
                ...state,
                resetLocalState: action.payload,
            };
        },
    },
    extraReducers(builder) {
        builder
            .addCase(updateSingleInvEv.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(updateSingleInvEv.fulfilled, (state, action) => {
                state.fetchedResponse = action.payload;
                state.editMode = true;
                state.bulkMode = false;
                state.submitLoading = false;
                toast.success("Updated Successfully", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(updateSingleInvEv.rejected, (state) => {
                state.submitLoading = false;
                toast.error("Error Occurred", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(updateBulkInvEv.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(updateBulkInvEv.fulfilled, (state, action) => {
                state.fetchedResponse = action.payload;
                state.editMode = true;
                state.bulkMode = true;
                state.submitLoading = false;
                toast.success("Updated Successfully", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(updateBulkInvEv.rejected, (state) => {
                state.submitLoading = false;
                toast.error("Error Occurred", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(saveSingleInvEv.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(saveSingleInvEv.fulfilled, (state, action) => {
                state.fetchedResponse = action.payload;
                state.editMode = true;
                state.bulkMode = false;
                state.submitLoading = false;
                state.selectAll = false;
                state.resetLocalState = true;
                toast.success("Saved Successfully", {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(saveSingleInvEv.rejected, (state, action) => {
                state.submitLoading = false;

                const errorMessage = action.payload || "Error Occurred";

                toast.error(errorMessage, {
                    autoClose: 5000,
                    containerId: "Modal",
                });
            })
            .addCase(saveConsolidatedBulkInvEv.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(saveConsolidatedBulkInvEv.fulfilled, (state, action) => {
                state.submitLoading = false;
                state.updateNeeded = true;
                toast.success(`${action.payload.eihCode} saved successfully!`, {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(saveConsolidatedBulkInvEv.rejected, (state, action) => {
                state.submitLoading = false;

                const errorMessage = action.payload || "Error Occurred";

                toast.error(errorMessage, {
                    autoClose: 5000,
                    containerId: "Modal",
                });
            })
            .addCase(savePlantWiseBulkInvEv.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(savePlantWiseBulkInvEv.fulfilled, (state, action) => {
                state.submitLoading = false;
                state.updateNeeded = true;
                toast.success(`${action.payload.eihCode} saved successfully!`, {
                    autoClose: 5000,
                    containerId: "Main",
                });
            })
            .addCase(savePlantWiseBulkInvEv.rejected, (state, action) => {
            state.submitLoading = false;

            const errorMessage = action.payload || "Error Occurred";

            toast.error(errorMessage, {
                autoClose: 5000,
                containerId: "Modal",
            });
        });
    },
});

export const invEvActions = invEvSlice.actions;
export default invEvSlice;
